let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lyb5Y")).then(() => parcelRequire('2L7l6'));